export const DefaultZIndexLevels = {
  level1: 10,
  level2: 20,
  level3: 30,
  level4: 40,
  level5: 50,
  level6: 60,
  level7: 70,
  level8: 80,
  level9: 90,
  level10: 100,
}

export type ZIndexLevels = typeof DefaultZIndexLevels
